import React from 'react';
import { Card } from '../../ui/card';
import { MarkdownContent } from './MarkdownContent';
import { stripReminderTags } from '../utils';

interface UserMessageProps {
  content: string;
  id: string;
  className?: string;
}

export const UserMessage: React.FC<UserMessageProps> = ({
  content,
  id,
  className = '',
}) => {
  const cleanContent = stripReminderTags(content);

  return (
    <Card
      className={`w-full bg-gray-200 text-gray-900 rounded px-4 py-2 ${className}`}
      data-msg-id={id}
    >
      <MarkdownContent content={cleanContent} variant="user" />
    </Card>
  );
};
